import './Max.css';
export var maxValue = '_16fswkf0-2-0-1';